import React, {useMemo} from 'react';
import {useOpenPopupData} from "../../logs/useTableData";
import {Button} from "antd";
import IsLoading from "../../../shared/components/IsLoading";
import ErrorPage from "../../../shared/components/ErrorPage";
import {MergeEventMasterTableEntity} from "../mergeEvent/MergeEventMasterTableEntity";
import TablePage from "../../../pages/tablePage/TablePage";
import {PopupMasterEntity} from "./PopupMasterEntity";
import {useSavePopup} from "./usePopup";

const PopupTable = () => {
    const { data: popupTableData, isLoading, error} = useOpenPopupData();
    const { mutate: savePopup } = useSavePopup();

    const handleSave = async (record) => {
        const row = new PopupMasterEntity(record);
        if (row.isInvalidate()) return;
        savePopup(row.toJson());
    }

    const columns = useMemo(() => [
        {
            title: '팝업 인덱스',
            dataIndex: 'index',
            key: 'index',
            sorter: (a, b) => a.index - b.index,
        },
        {
            title: '팝업 이름',
            dataIndex: 'name',
            key: 'name',
        },
        {
            title: '오픈 레벨',
            dataIndex: 'openLevel',
            key: 'openLevel',
        },
        {
            title: '액션',
            render: (record) => (
                <Button onClick={() => handleSave(record)}>
                    {'추가하기'}
                </Button>
            )
        }
    ], []);

    if (isLoading) return <IsLoading/>;
    if (error) return <ErrorPage error={error}/>;

    const props = {
        columns,
        isLoading: isLoading,
        localData: popupTableData || [],
        entityModel: PopupMasterEntity,
    }

    return (
        <TablePage
            {...props}
        />
    );
};

export default PopupTable;